import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PhUploadComponent } from './ph-upload.component';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { PhCropperModule } from '@shared/components/ph-cropper/ph-cropper.module';
import { PhotoComponent } from './components/photo/photo.component';
import { ReactiveFormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { HttpLoaderFactory } from 'src/app/app.functions';
import { DialogModule } from 'primeng/dialog';
import { PhLoaderModule } from '../ph-loader/ph-loader.module';

@NgModule({
  declarations: [PhUploadComponent, PhotoComponent],
  exports: [PhUploadComponent],
  imports: [
    CommonModule,
    DialogModule,
    PhLoaderModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
      isolate: true,
    }),
    PhCropperModule,
    ReactiveFormsModule,
  ],
})
export class PhUploadModule {}
